var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', {
    staticClass: "wrap--join"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('h2', {
    staticClass: "join-title"
  }, [_vm._v("회원가입")]), _c('div', {
    staticClass: "join-container"
  }, [_c('div', {
    staticClass: "join-gate"
  }, [_c('div', {
    staticClass: "join-gate-box join-gate-box--personal"
  }, [_c('div', {
    staticClass: "join-gate-box__inner"
  }, [_c('i', {
    staticClass: "icon icon-general"
  }), _c('h2', [_vm._v("개인회원 가입")]), _c('p', [_vm._v("전자제조지원단 및 일반회원")]), _c('button', {
    staticClass: "button button--primary min-w150 min-md-wauto",
    on: {
      "click": function click($event) {
        return _vm.submit(_vm.USER_TYPES.INDIVIDUAL);
      }
    }
  }, [_vm._v(" 가입하기 ")])])]), _c('div', {
    staticClass: "join-gate-box join-gate-box--business"
  }, [_c('div', {
    staticClass: "join-gate-box__inner"
  }, [_c('i', {
    staticClass: "icon icon-business"
  }), _c('h2', [_vm._v("기업회원 가입")]), _c('p', [_vm._v("일반기업 및 유관기업")]), _c('button', {
    staticClass: "button button--primary min-w150 min-md-wauto",
    on: {
      "click": function click($event) {
        return _vm.submit(_vm.USER_TYPES.ORGANIZATION);
      }
    }
  }, [_vm._v(" 가입하기 ")])])])])])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }